/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'

function prepareParams(config) {
    const field =
        config.sortDirection === 'desc' ? `-${config.sort}` : config.sort

    const params = {
        page: config.page,
        include: config.include,
        sort: field,
        per_page: config.per_page
    }

    if (config.search) params.search = config.search

    if (config.filters) {
        for (const [key, value] of Object.entries(config.filters)) {
            if (value === null || value === undefined || value === '') continue
            params[`filter[${key}]`] = value
        }
    }

    return params
}

export default {
    getArticles({ state, rootState, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/news`, {
                    params: prepareParams(state.articlesConfig)
                })
                .then((response) => {
                    commit('setArticles', response.data.articles)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    getArticle({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/news/${id}`, {
                    params: { include: 'category,coverMedia,createdBy,translations' }
                })
                .then((response) => {
                    commit('setArticle', response.data.article)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    createArticle({ rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/news`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    updateArticle({ rootState }, { id, payload }) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/news/${id}`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    deleteArticle({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${rootState.baseURL}/news/${id}`)
                .then(resolve)
                .catch(reject)
        })
    },

    publishArticle({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/news/${id}/publish`)
                .then(resolve)
                .catch(reject)
        })
    },

    unpublishArticle({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/news/${id}/unpublish`)
                .then(resolve)
                .catch(reject)
        })
    },

    getCategories({ state, rootState, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/news-categories`, {
                    params: prepareParams(state.categoriesConfig)
                })
                .then((response) => {
                    commit('setCategories', response.data.categories)
                    resolve(response)
                })
                .catch(reject)
        })
    },

    createCategory({ rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/news-categories`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    updateCategory({ rootState }, { id, payload }) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/news-categories/${id}`, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    deleteCategory({ rootState }, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${rootState.baseURL}/news-categories/${id}`)
                .then(resolve)
                .catch(reject)
        })
    }
}
